<template>
  <app-page-section
    :title="{
      tag: 'h3',
      text: 'Pollen vous accompagne à chaque étape',
    }"
  >
    <app-page-three-column-card :columns="reassuranceItems" />

    <template #append>
      <growth-contact-button
        :origin="origin"
        origin_page_action="how_it_works_banner_cta"
        size="xl"
      >
        Prendre rendez-vous
      </growth-contact-button>
    </template>
  </app-page-section>
</template>

<script lang="ts" setup>
import type { PageColumnCardDefinition } from "~/shared/page/page.model";
import type { ContactFlowOriginPage } from "~~/model/analytics.model";

defineProps<{
  origin: ContactFlowOriginPage;
}>();

const reassuranceItems: PageColumnCardDefinition[] = [
  {
    title: "Je sélectionne le thème et le trainer",
    subtitle:
      "Notre équipe peut vous aider à qualifier votre besoin et à trouver la meilleure personne pour vous former.",
    illustration: "/images/brand/session/interior_3.jpg",
  },
  {
    title: "Nous préparons la session ensemble",
    subtitle:
      "Vous rencontrez le trainer pour expliquer vos enjeux. Nous construisons la session adaptée avec le trainer et la méthodologie Pollen.",
    illustration: "/images/brand/session/interior_4.jpg",
  },
  {
    title: "Vos talents se forment avec le trainer",
    subtitle:
      "Chaque participant recevra un support de formation et un certificat qui atteste sa formation.",
    illustration: "/images/brand/session/interior_5.jpg",
  },
];
</script>
